import * as React from 'react'

import { Box, Link } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import Content from 'modules/timeoff/components/MedicalLeaveContent'

import useCopies from './useCopies'
// Hooks
import useUpdateMedicalLeaveUpdate from './useUpdateMedicalLeaveUpdate'

interface Props {
  leaveUpdateId: string
  onClose: () => void
}

const EditMedicalLeaveUpdatePage = ({ leaveUpdateId, onClose }: Props) => {
  const updateData = useUpdateMedicalLeaveUpdate({
    leaveUpdateId,
    onClose,
  })

  const { leaveUpdate, form, loading: updateLoading, onSubmit, minEffectiveOn } = updateData
  const leaveTypeValue = form.get('leave_update_type').value

  const { title, description } = useCopies({
    leaveTypeValue,
  })

  const isLoading = updateLoading

  return (
    <Modal
      illustration="user-tie"
      title={title}
      description={description}
      onSubmit={onSubmit}
      onClose={onClose}
    >
      {isLoading && <Loading />}
      {!isLoading && (
        <>
          <Content
            readOnly
            form={form}
            leaveUpdate={leaveUpdate}
            medicalLeaveType={leaveUpdate?.leave.attributes.medical_leave_type}
            minEffectiveOn={minEffectiveOn}
          />
          <Box paddingX="s16">
            <Link.Href
              href={helpCenterUrl('new_request')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {i18n.t('time_off.medical_leave.not_editable_notice.link')}
            </Link.Href>
          </Box>
        </>
      )}
    </Modal>
  )
}

export default EditMedicalLeaveUpdatePage
